module.exports = __webpack_public_path__ + "img/LoginBakImg@2x.330d5491.png";